// Top bar USPs are plain <a> without href in header.liquid (text, no click, no tab stop); this also covers
// pages still cached with the old href="#" markup.
document.querySelectorAll('#header-top-row a[href="#"]').forEach((usp) => usp.removeAttribute('href'));

// Menu images are output with data-src/data-srcset (header.liquid) and get their real source here, once the menu
// is wanted. content-visibility also keeps the closed menus unrendered, but browsers without it (Safari before 18)
// would otherwise fetch every lazy menu image on each page view.
const loadDeferredImages = (root, selector = 'img[data-src]') => {
  root.querySelectorAll(selector).forEach((img) => {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  });
};

// Mobile menu: its tiles stay unrendered while the menu is closed (style.css, html:not(.st-mm-warm)) and their
// images only load once the visitor reaches for the burger.
(() => {
  const menu = document.querySelector('#mobile-menu');
  const opener = document.querySelector('#menu-open');
  if (!menu) return;

  const warm = () => {
    document.documentElement.classList.add('st-mm-warm');
    loadDeferredImages(menu);
  };
  ['pointerdown', 'touchstart', 'focus'].forEach((type) => opener?.addEventListener(type, warm, { once: true, passive: true }));

  // Tell assistive tech whether the burger's menu is open (the theme toggles .active on #mobile-menu); an opened
  // menu also gets its images in case it was opened without touching the burger first
  new MutationObserver(() => {
    const open = menu.classList.contains('active');
    opener?.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) warm();
  }).observe(menu, { attributes: true, attributeFilter: ['class'] });
})();

(() => {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const items = Array.from(document.querySelectorAll('[data-mega-menu-item]'));
  const menuWrapper = document.querySelector('#header-menu-wrapper');
  let openTimer;
  let closeTimer;
  let pendingItem;
  let suppressNextFocusOpen = false;

  if (!items.length) return;

  // Render the closed panels and load their illustrations and banners once the visitor heads for the menu; on desktop
  // the small illustrations also load a moment after the page has loaded (never on phones, where the mega menu is not
  // shown)
  if (menuWrapper) {
    const loadArt = () => loadDeferredImages(menuWrapper, 'img.mega-menu__art[data-src]');
    const warm = () => {
      menuWrapper.classList.add('is-warm');
      loadDeferredImages(menuWrapper);
    };
    menuWrapper.addEventListener('pointerenter', warm, { once: true });
    menuWrapper.addEventListener('focusin', warm, { once: true });
    window.addEventListener('load', () => {
      if (!desktopQuery.matches) return;
      const later = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
      later(loadArt, { timeout: 4000 });
    });
  }

  // "Alle Produkte anzeigen" under the sub links, pointing to the parent category (the heading link).
  // Added here because the markup lives in header.liquid; only for menus whose heading is a collection.
  items.forEach((item) => {
    const categories = item.querySelector('.mega-menu__categories');
    const heading = categories?.querySelector('.mega-menu__heading');
    const href = heading?.getAttribute('href') || '';
    if (!categories || !/\/collections\//.test(href) || categories.querySelector('.mega-menu__all')) return;

    const all = document.createElement('a');
    all.className = 'mega-menu__all';
    all.href = href;
    all.innerHTML = '<span>Alle Produkte anzeigen</span><span class="mega-menu__all-arrow" aria-hidden="true">&rarr;</span>';
    categories.appendChild(all);
  });

  const setOpen = (item, open) => {
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const menu = item.querySelector('[data-mega-menu]');

    item.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', String(open));
    menu?.setAttribute('aria-hidden', String(!open));
  };

  const closeAll = (except = null) => {
    items.forEach((item) => {
      if (item !== except) setOpen(item, false);
    });
  };

  // Opening next to an already open panel: swap without the fade/slide so the panel stays put
  const swap = (item, instant) => {
    if (instant && menuWrapper) {
      menuWrapper.classList.add('is-switching');
      closeAll(item);
      setOpen(item, true);
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => menuWrapper.classList.remove('is-switching'));
      });
      return;
    }
    closeAll(item);
    setOpen(item, true);
  };

  const cancelTimers = () => {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    pendingItem = null;
  };

  const cancelPendingOpen = (item = null) => {
    if (item && pendingItem !== item) return;

    window.clearTimeout(openTimer);
    pendingItem = null;
  };

  const scheduleOpen = (item) => {
    cancelTimers();

    const trigger = item.querySelector('[data-mega-menu-trigger]');

    const hasAnotherOpenItem = items.some(
      (candidate) => candidate !== item && candidate.classList.contains('is-open')
    );

    pendingItem = item;
    openTimer = window.setTimeout(() => {
      // A pointer can briefly cross another top-level item while travelling
      // into the open panel. Never let that stale hover timer switch menus
      // after the pointer has already left its trigger.
      if (pendingItem !== item || !trigger?.matches(':hover')) {
        if (pendingItem === item) pendingItem = null;
        return;
      }

      pendingItem = null;
      swap(item, hasAnotherOpenItem);
    }, hasAnotherOpenItem ? 220 : 0);
  };

  const scheduleClose = (item) => {
    cancelPendingOpen(item);

    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => {
      if (item.classList.contains('is-open')) setOpen(item, false);
    }, 280);
  };

  items.forEach((item) => {
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const menu = item.querySelector('[data-mega-menu]');

    trigger?.addEventListener('pointerenter', () => {
      if (!desktopQuery.matches) return;
      scheduleOpen(item);
    });

    trigger?.addEventListener('pointerleave', () => {
      if (!desktopQuery.matches) return;

      cancelPendingOpen(item);
      if (item.classList.contains('is-open')) scheduleClose(item);
    });

    const keepPanelOpen = () => {
      if (!desktopQuery.matches) return;

      cancelTimers();
      if (!item.classList.contains('is-open')) {
        closeAll(item);
        setOpen(item, true);
      }
    };

    menu?.addEventListener('pointerenter', keepPanelOpen);
    menu?.addEventListener('pointermove', keepPanelOpen, { passive: true });
    menu?.addEventListener('wheel', keepPanelOpen, { passive: true });

    menu?.addEventListener('pointerleave', (event) => {
      if (!desktopQuery.matches || item.contains(event.relatedTarget)) return;
      scheduleClose(item);
    });

    item.addEventListener('focusin', () => {
      if (!desktopQuery.matches) return;
      if (suppressNextFocusOpen) {
        suppressNextFocusOpen = false;
        return;
      }
      cancelTimers();
      closeAll(item);
      setOpen(item, true);
    });

    item.addEventListener('focusout', (event) => {
      if (!desktopQuery.matches || item.contains(event.relatedTarget)) return;
      cancelTimers();
      setOpen(item, false);
    });
  });

  menuWrapper?.addEventListener('pointerleave', () => {
    window.clearTimeout(openTimer);
    pendingItem = null;
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(() => closeAll(), 280);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openItem = items.find((item) => item.classList.contains('is-open'));
    if (!openItem) return;

    const trigger = openItem.querySelector('[data-mega-menu-trigger]');
    setOpen(openItem, false);
    suppressNextFocusOpen = true;
    trigger?.focus();
  });

  desktopQuery.addEventListener?.('change', () => {
    cancelTimers();
    closeAll();
  });
})();

// Desktop navigation: mark the top-level item of the area the visitor is in (yellow underline, like the active
// category in the collection sidebar). The current page, or on a product page the category from its breadcrumb,
// is looked up among the links of each menu item; blog articles belong to the item that links the blog.
(() => {
  const items = Array.from(document.querySelectorAll('#header-menu-wrapper > .header-menu > .header-menu__item'));
  if (!items.length) return;
  const clean = (href) => {
    try {
      return new URL(href, location.origin).pathname.replace(/\/+$/, '').toLowerCase();
    } catch (error) {
      return '';
    }
  };
  const candidates = [];
  let path = clean(location.href);
  const productPath = path.match(/\/products\/[^/]+$/);
  if (productPath) {
    candidates.push(productPath[0]);
    const crumb = document.querySelector('#the-breadcrumbs a[href*="/collections/"]');
    if (crumb) candidates.push(clean(crumb.getAttribute('href')));
    const collectionInPath = path.match(/^\/collections\/[^/]+/);
    if (collectionInPath) candidates.push(collectionInPath[0]);
  } else {
    candidates.push(path);
    const blog = path.match(/^\/blogs\/[^/]+/);
    if (blog) candidates.push(blog[0]);
  }
  if (!candidates.length || candidates[0] === '' || candidates[0] === '/') return;

  for (const candidate of candidates) {
    const match = items.find((item) => Array.from(item.querySelectorAll('a[href]')).some((link) => clean(link.getAttribute('href')) === candidate));
    if (match) {
      match.classList.add('is-current');
      match.querySelector(':scope > .header-menu__link')?.setAttribute('aria-current', 'true');
      break;
    }
  }
})();
